import { motion } from "framer-motion";
import { Home, Building2, Truck, Sofa, Armchair, Layers, Grid3x3, ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/content";

const ICONS = { Home, Building2, Truck, Sofa, Armchair, Layers, Grid3x3 };

export default function Services() {
  const go = () => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="label-caps mb-4">What We Clean</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1A2A5E]">
            Premium cleaning for every surface in your space.
          </h2>
          <p className="mt-4 text-[#475569] text-lg">
            From wall-to-wall carpet to patio furniture, we use the right method for every fibre — no shortcuts, no surprises.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Home;
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                className="group bg-white border border-[#E2E8F0] rounded-sm overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
              >
                <div className="h-44 overflow-hidden">
                  <img src={s.img} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="w-11 h-11 -mt-11 relative z-10 bg-[#1A2A5E] rounded-sm flex items-center justify-center text-white mb-4 shadow-lg">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display text-lg font-bold text-[#0F172A]">{s.name}</h3>
                  <p className="mt-2 text-sm text-[#475569] leading-relaxed">{s.blurb}</p>
                  <button onClick={go} className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-[#2B4BB8] hover:gap-2 transition-all">
                    Request quote <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
